import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const cookiesAceptadas = localStorage.getItem('cookiesAceptadas');
    if (!cookiesAceptadas) {
      setVisible(true);
    }
  }, []);

  const aceptarCookies = () => {
    localStorage.setItem('cookiesAceptadas', 'true');
    setVisible(false);
    // Aquí puedes activar Google Analytics u otras cookies
  };

  const rechazarCookies = () => {
    localStorage.setItem('cookiesAceptadas', 'false');
    setVisible(false);
    // Aquí desactivas todas las cookies no esenciales
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#1A1A1A',
      color: 'white',
      padding: '1rem 2rem',
      zIndex: 9999,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '1rem',
      boxShadow: '0 -4px 20px rgba(0,0,0,0.2)'
    }}>
      <div style={{ flex: 1 }}>
        <p style={{ margin: 0 }}>
          🍪 Usamos cookies para mejorar tu experiencia. 
          Puedes aceptarlas, rechazarlas o consultar nuestra 
          <a href="/politica-cookies" style={{ color: '#9DD8CC', marginLeft: '5px' }}>Política de Cookies</a>.
        </p>
      </div>
      <div style={{ display: 'flex', gap: '1rem' }}>
        <button 
          onClick={rechazarCookies}
          style={{
            background: 'transparent',
            border: '1px solid #9DD8CC',
            color: '#9DD8CC',
            padding: '8px 20px',
            borderRadius: '30px',
            cursor: 'pointer'
          }}
        >
          Rechazar
        </button>
        <button 
          onClick={aceptarCookies}
          style={{
            background: '#9DD8CC',
            border: 'none',
            color: '#1A1A1A',
            padding: '8px 20px',
            borderRadius: '30px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          Aceptar
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;